import { DatePipe, Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { LocationModel, Registration } from 'src/app/models/login/login';
import { RegistorpatientService } from 'src/app/services/registorpatient.service';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { madisonPatientRecord, UpdatemadisonPatientRecord, auth } from 'src/app/models/verifypatient/verifypatient';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PaymentService } from 'src/app/services/payment.service';
import { CityStateModel, CreditCardEncriptionModel, PaymentDeiails, practiceDetails } from 'src/app/models/registeration/payment_models';

import { ExitingpatientService } from 'src/app/services/exitingpatient.service';
declare var $: any;

@Component({
  selector: 'app-medison-registration',
  templateUrl: './medison-registration.component.html',
  styleUrls: ['./medison-registration.component.css']
})
export class MedisonRegistrationComponent  implements OnInit, OnDestroy {
  isValidEmail: boolean = true;
  isNotCellPhone: boolean = false;
  isNotValidPhone: boolean = false;
  isShowVerifyButton: boolean = false;
  registration: any;
  Update_madisonPatientRecord: UpdatemadisonPatientRecord = new UpdatemadisonPatientRecord();
  otpCountDown: any;
  isOtpentered: boolean = true;
  verifiedCellPhone: boolean = false;
  practice_code: any;
  practice_name: any;
  tempMaritalStatus : any
  curDate = new Date();
  tempGeneder : any
  getMadisondetails : any;
  Madisondetails : madisonPatientRecord;
  cityStateList: CityStateModel[] = [];
  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput!: NgOtpInputComponent;
  config: NgOtpInputConfig = {
    allowNumbersOnly: false,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    letterCase: 'Upper'
  };
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
   maxDate: any;
  registrationForm: UntypedFormGroup = new UntypedFormGroup({});

  constructor(private spinner: NgxSpinnerService,private phrUtils: PhrutillsService,private service: PaymentService, private _phrutilService: PhrutillsService,private _login: ExitingpatientService, private _registor: RegistorpatientService, private datepipe: DatePipe,
    private _router: Router, private _route: ActivatedRoute, private location: Location) {
    this.registration = new Registration();
    this.maxDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.reset();
    this.Madisondetails = new madisonPatientRecord();
    this.getMadisondetails = this._router.getCurrentNavigation()?.extras.state;
    
      this.Madisondetails.address = this.getMadisondetails.unReadFaxCount.address;
      this.Madisondetails.cell_phone = this.getMadisondetails.unReadFaxCount.cell_phone;
      this.Madisondetails.city = this.getMadisondetails.unReadFaxCount.city;
      this.Madisondetails.date_Of_Birth = this.getMadisondetails.unReadFaxCount.date_Of_Birth;
      this.Madisondetails.first_Name = this.getMadisondetails.unReadFaxCount.first_Name;
      this.Madisondetails.gender = this.getMadisondetails.unReadFaxCount.gender;
      this.Madisondetails.last_Name = this.getMadisondetails.unReadFaxCount.last_Name;
      this.Madisondetails.marital_Status = this.getMadisondetails.unReadFaxCount.marital_Status;
      this.Madisondetails.patient_Account = this.getMadisondetails.unReadFaxCount.patient_Account;
      this.Madisondetails.practice_Code = this.getMadisondetails.unReadFaxCount.practice_Code;
      this.Madisondetails.state = this.getMadisondetails.unReadFaxCount.state;
      this.Madisondetails.zip = this.getMadisondetails.unReadFaxCount.zip;
      this.Madisondetails.email_Address = this.getMadisondetails.unReadFaxCount.email_Address;

      this.setValues();
   
  }

  buildregistrationForm() {
    this.registrationForm = new UntypedFormGroup({
     // location: new UntypedFormControl('', Validators.required),
      firstname: new UntypedFormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
      lastname: new UntypedFormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
      gender: new UntypedFormControl('', Validators.required),
      maritalstatus: new UntypedFormControl('', Validators.required),
      dob: new UntypedFormControl('', Validators.required),
      email: new UntypedFormControl('', Validators.email),
      Address: new UntypedFormControl('', Validators.required),
      state: new UntypedFormControl('', Validators.required), //city
      city: new UntypedFormControl('', Validators.required),
      zip: new UntypedFormControl('', [Validators.required, Validators.minLength(9)]),
      cell: new UntypedFormControl('', [Validators.required, Validators.minLength(9)]),
      occupation: new UntypedFormControl('', Validators.required),
      employer: new UntypedFormControl('', Validators.required),
    });
  }


  ngOnInit(): void {
    // this._route.queryParams.subscribe((params: Params) => {
    //   localStorage.clear();
    //   if (params['practice_code'] != null) {
    //     this.VerifyPractice(params['practice_code']);
    //   }
    //   else {
    //     localStorage.clear();
    //     $("#isNotValid_link").modal("show");
    //     return;
    //   }
    // }, error => {
    //   localStorage.clear();
    //   $("#isNotValid_link").modal("show");
    //   return;
    // });
  }

  focusOutFunction(e: any, type: any) {
    if ((new Date(this.maxDate)) < (new Date(this.registrationForm.get('dob')!.value))) {
      this.getregistrationForm.dob.setErrors({ 'maxDate': true, 'invalid': true });
    }
  }


  ValidatePersonalInfo(data: any, type: any) {
    let validname = data.target.value.replace(/[^a-zA-Z ]/g, "");
    data.target.value = validname;
    if (type == 'firstname') {
      if (validname != '') {
        this.registration.first_Name = validname;
      } else {
        this.registration.first_Name = validname;
      }
    } else if (type == 'lastname') {
      if (validname != '') {
        this.registration.last_Name = validname;
      }
      else {
        this.registration.last_Name = validname;
      }
    }
  }

  validatePhoneNo(field: any) {
    let phoneNumDigits = field.value.replace(/\D/g, '');
    field.value = phoneNumDigits;
    let isValidPhone = (phoneNumDigits.length == 0 || phoneNumDigits.length == 10);
    if (isValidPhone) {
      field.value = this._phrutilService.maskingPhoneNumer(phoneNumDigits);
    } else {
      field.value = phoneNumDigits;
    }
  }

  validatePhone(phoneNumDigits: any, type: any) {
    let dummyPhone = phoneNumDigits.replace(/\D/g, '');
    phoneNumDigits = dummyPhone.replace(/\s/g, '');
    if (type == "phone") {
      if (phoneNumDigits.length == 0 || phoneNumDigits.length == 14 || phoneNumDigits.length == 10) {
        this.isNotValidPhone = false;
        if (phoneNumDigits.length != 0) {
          this.isShowVerifyButton = true;
          this.isNotCellPhone = false;
        }
      }
      else {
        this.isNotValidPhone = true;
        this.isShowVerifyButton = false;
      }
    }
  }

  onFocusOutLocation(data: any, type: any) {

    if (data.value) {
      if (type == 'maritalstatus') {
        this.registration.maritalstatus = data.value;
      }
      else if (type == 'gender') {
        this.registration.gender = data.value;
      }
    }

  }

  get getregistrationForm() {
    return this.registrationForm.controls;
  }

  reset() {
    this.registrationForm.reset();
    this.buildregistrationForm();
  }

  setValues(){
   
    this.registrationForm.controls["firstname"].setValue(this.Madisondetails.first_Name);
    this.registrationForm.controls["lastname"].setValue(this.Madisondetails.last_Name);
    //this.registrationForm.controls["dob"].setValue(this.Madisondetails.date_Of_Birth);
    this.registrationForm.controls["dob"].setValue(this.datepipe.transform(new Date(this.Madisondetails.date_Of_Birth), 'yyyy-MM-dd'));
    //this.datepipe.transform(new Date(this.registrationForm.get('dob')!.value), 'MM/dd/yyyy');
    this.registrationForm.controls["gender"].setValue(this.Madisondetails.gender);
    this.registrationForm.controls["maritalstatus"].setValue(this.Madisondetails.marital_Status);

    this.registrationForm.controls["Address"].setValue(this.Madisondetails.address);
    this.registrationForm.controls["zip"].setValue(this.Madisondetails.zip);
    this.registrationForm.controls["state"].setValue(this.Madisondetails.state);
    this.registrationForm.controls["city"].setValue(this.Madisondetails.city);
    this.registrationForm.controls["email"].setValue(this.Madisondetails.email_Address);

    let phoneNumDigits = this.Madisondetails.cell_phone
    let  formattedNumber = '(' + phoneNumDigits.substring(0, 3) + ') ' + phoneNumDigits.substring(3, 6) + '-' + phoneNumDigits.substring(6);
    this.registrationForm.controls["cell"].setValue(formattedNumber);

    this.tempMaritalStatus = this.Madisondetails.marital_Status;
    this.tempGeneder = this.Madisondetails.gender
    
    

  }

// select a state upon city name selection
showState(e: any) {
  let c = e.target.value;
  this.cityStateList.map(city => {
    if (city.cityName === c) {
     this.registrationForm.controls["state"].setValue(city.stateCode);
    }
  });
}

  removeStateCity() {
    this.cityStateList = [];
    this.cityStateList.length = 0;
   // this.getpaymentForm["city"].setValue('');
  //  this.getpaymentForm["state"].setValue('');
  this.registrationForm.controls["city"].setValue('');
  this.registrationForm.controls["state"].setValue('');
  }
  onlyNumberAllow(e: any): boolean {
  
    e.target.value = e.target.value.replace(/\D/g, '');
    e.target.value = this.phrUtils.maskingZipNum(e.target.value);
    if (e.target.value.length == 10 || e.target.value.length == 5) {
      this.getZipCityState(e);
      return false;
    }
    if(e.target.value.length <5 || e.target.value.length  < 10){
     // this.removeStateCity();
    }

    const charCode = (e.which) ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    else {
      return true;
    }
  }
  getZipCityState(e: any) {
    let v = e.target.value;
    if (v.length < 5) {
      return;
    }
    this.spinner.show();
    let patient_account = this.Madisondetails.patient_Account;
    let practice_Code = this.Madisondetails.practice_Code;
    this._login.getZip(v,patient_account,practice_Code).subscribe((res: any) => {
      this.spinner.hide();
      if (res.statusCode == 200 && res.data.length > 0) {
        
         this.cityStateList = res.data as CityStateModel[];
         
         this.registrationForm.controls["city"].setValue(this.cityStateList[0].cityName);
         this.registrationForm.controls["state"].setValue(this.cityStateList[0].stateCode);
         this.registrationForm.controls["zip"].setValue(this.cityStateList[0].zipCode);
        //  this.getpaymentForm["city"].setValue(this.cityStateList[0].cityName);
        // this.getpaymentForm["state"].setValue(this.cityStateList[0].stateCode);
      }
      else if (res.statusCode == 404) {
        // this.getpaymentForm["zip"].setErrors({invalid: true, required: true});
        this.removeStateCity();
      }
      else {
        // this.getpaymentForm["zip"].setErrors({invalid:true, required: true});
        this.removeStateCity();
      }
    },
    (error: any) => {
      this.spinner.hide();
      this.phrUtils.showError("Service is not available, please try later.");
    });
  }

  RegistrationResponce: any;
  RegistorPatient() {

    
    
// if (this.registrationForm.valid) {
      this.spinner.show();
      this.registration.date_Of_Birth = this.datepipe.transform(new Date(this.registrationForm.get('dob')!.value), 'MM/dd/yyyy');
      this.registration.practice_Code = this.practice_code;
      this.registration.email_Address = this.registrationForm.get('email')!.value;
      this.registration.last_Name = this.registrationForm.get('lastname')!.value;
      this.registration.first_Name = this.registrationForm.get('firstname')!.value;
      this.registration.gender = this.registrationForm.get('gender')!.value;
      this.registration.maritalstatus = this.registrationForm.get('maritalstatus')!.value;
      this.registration.cell_phone = this.registrationForm.get('cell')!.value.replace(/\D/g, ''); //state
      this.registration.zip = this.registrationForm.get('zip')!.value;
      this.registration.state = this.registrationForm.get('state')!.value;
      this.registration.city = this.registrationForm.get('city')!.value;
      this.registration.address = this.registrationForm.get('Address')!.value;

      this.Update_madisonPatientRecord.patient_Account = this.Madisondetails.patient_Account;
      this.Update_madisonPatientRecord.practice_Code = this.Madisondetails.practice_Code;
      
      this.Update_madisonPatientRecord.date_Of_Birth =  this.registration.date_Of_Birth;
      this.Update_madisonPatientRecord.first_Name = this.registration.first_Name;
      this.Update_madisonPatientRecord.gender =  this.registration.gender;
      this.Update_madisonPatientRecord.marital_Status =  this.registration.maritalstatus;
      this.Update_madisonPatientRecord.address = this.registration.address;
      this.Update_madisonPatientRecord.city = this.registration.city;
      this.Update_madisonPatientRecord.state = this.registration.state;
      this.Update_madisonPatientRecord.zip =  this.registration.zip;
      this.Update_madisonPatientRecord.phoneNo = this.registration.cell_phone;
      this.Update_madisonPatientRecord.email_Address =  this.registration.email_Address;
      this.Update_madisonPatientRecord.last_Name = this.registration.last_Name;

      //concatenating Empolyer and Occupation
      let Emp = this.registrationForm.get('employer')!.value;
      let Occ = this.registrationForm.get('occupation')!.value;
     this.Update_madisonPatientRecord.occupationEmployerInfo = 'Employer: ' + Emp + ', ' + 'Occupation: ' + Occ +'.';
     
   // occupationEmployerInfo

      // });
      this._login.UpdateMadisonpatient(this.Update_madisonPatientRecord).subscribe((res: any) => {
        
        this.spinner.hide();
        if (res && res.statusCode == 200) {

          this._phrutilService.showSuccess("Record updated successfully");

          this._router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
                        this._router.navigateByUrl("/madison-insurance", { state: { unReadFaxCount: this.Madisondetails} })
                    })
         //  this._router.navigateByUrl('/madison-insurance');


        } else {
          this._phrutilService.showError("Please filled all the *mandatory fields first.");
        
        }
      }, (error: any) => {
       
        this._phrutilService.showError("Please filled all the *mandatory fields first.");
       
        this.spinner.hide();
      });
    
  //  }

    // else {
    //   this._phrutilService.showInfo('Please filled all the *mandatory fields first.');
    //   this.registrationForm.markAllAsTouched();
    // }
   
  }

  checkFieldValidaiton() {
    if (this.registrationForm.get('dob')!.value) {
      if ((new Date(this.maxDate)) < (new Date(this.registrationForm.get('dob')!.value))) {
        this._phrutilService.showInfo('Future date of birth is not allowed.');
        return false;
      }
    }
    if (!this.registrationForm.get('cell')!.value || this.registrationForm.get('cell')!.value.length == 0) {
      this.isNotCellPhone = true;
      return false;
    }
    else {
      this.isNotCellPhone = false;
      return true;
    }
  }

  phoneLink: string;
  linkType: string;
  otpResp: any = null;
  SendOTP() {
    this.registrationForm.markAllAsTouched();
    if (!this.checkFieldValidaiton() && this.registrationForm.invalid) {
      return;
    }

    let p = this.registrationForm.get('cell')!.value.replace(/\D/g, '');

    this.phoneLink = p;
    this.linkType = 'phone number';
    this.phoneLink = '*** *** **' + this.phoneLink.substring(this.phoneLink.length - 4, this.phoneLink.length);

    let obj = {
      "applicationName": "BreezeCheckin",
      "userName": p,
      "deviceInfo": "web",
      "appDisplayName": "Breeze Checkin"
    };
    this.spinner.show();
    this._registor.SendOTP(obj).subscribe((res: any) => {
      this.spinner.hide();
      if (res.status == true && res.message.toLowerCase() == 'otp sent') {
        $('#verifycode').modal('show');
        this.otpResp = res;
        $('#ngotp .ng-otp-input-wrapper').removeClass("wrapper");
        this.OTPTimer(179);
        this.ngOtpInput.setValue('');
      }
      else {
        this._phrutilService.showError(res.message);
      }
    }, (error: any) => {
      this._phrutilService.showError(error.toString());
      this.spinner.hide();
    });
  }

  //otp timer starts
  m: string = '00';
  s: string = '00';
  timer: any;
  remainingTime: number = 0;
  OTPTimer(remaining: any) {
    this.remainingTime = remaining;
    this.m = Math.floor(remaining / 60).toString();
    this.s = (remaining % 60).toString();
    this.m = Number(this.m) < 10 ? '0' + this.m : this.m;
    this.s = Number(this.s) < 10 ? '0' + this.s : this.s;

    this.timer = setTimeout(() => {
      if (remaining >= 1) {
        remaining -= 1;
        this.OTPTimer(remaining);
      }
      else {
        return;
      }
    }, 1000);
  }

  verResp: any = null;
  otpEntered: boolean = true;
  verifyOTP() {
    if (this.otpResp == null) {
      return;
    }
    if (Number(this.s) == 0 && Number(this.m) == 0) {
      this._phrutilService.showError("Code expired. Tap resend code and try again.");
      return;
    }

    if (this.otp && this.otp.length == 4) {
      this.otpEntered = true;
      let obj = {
        "deviceInfo": "web",
        "notifier": this.otpResp.data,
        "otp": this.otp
      };
      this.spinner.show();
      this._registor.VerifyOTP(obj).subscribe((res: any) => {
        this.isVerifying = false;
        this.spinner.hide();
        this.verResp = res;
        if (res.status == true && res.message == "OTP verified successfully") {
          $('#verifycode').modal('hide');
          this.verifiedCellPhone = true;
        }
        else if (res.message.includes('failed')) {
          this._phrutilService.showError("Invalid OTP Code. Try again.");
        }
      }, (error: any) => {
        this.isVerifying = false;
        this._phrutilService.showError(error.toString());
        this.spinner.hide();
      });
    }
    else {
      this.otpEntered = false;
    }
  }

  otp: string = '';
  isVerifying: boolean = false;
  onOtpChange(otp: any) {
    if (this.isVerifying) {
      return;
    }
    this.otp = otp;
    if (this.otp.length == 4) {
      this.isVerifying = true;
      this.verifyOTP();
    }
  }

  providerLocation: any;
  getLocation(practice_code: any) {
    this.spinner.show();
    this._registor.GetLocation(practice_code).subscribe((res: any) => {
      this.spinner.hide();
      if (res.data && res.data.locations.length != 0) {
        let LocationTemp = res.data.locations as LocationModel[];
        let LocationTemp_1 = LocationTemp.filter(data => data.locationName != "");
        this.providerLocation = LocationTemp_1;
      }
      else {
        this._phrutilService.showError("Service is not available, please try later.");
        return;
      }
    },
      (error: any) => {
        this.spinner.hide();
        this._phrutilService.showError("Service is not available, please try later.");
      });
  }

  VerifyPractice(practice_code: any) {
    this.spinner.show();
    this._registor.VerifyPracticeCode(practice_code).subscribe((res: any) => {
      this.spinner.hide();
      if (res.data && res.statusCode == 200) {
        this.practice_code = res.data.practice_Code;
        this.practice_name = res.data.prac_Name;
        this.getLocation(this.practice_code);
      }
      else {
        $("#isNotValid_link").modal("show");
        return;
      }
    },
      (error: any) => {
        this.spinner.hide();
        $("#isNotValid_link").modal("show");
      });
  }

  validateEmailAddress(event: any) {
    if (event.value.length > 0) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.value)) {
        this.isValidEmail = true;
      }
      else {
        this.isValidEmail = false;
      }
    }
    else {
      this.isValidEmail = true;
    }
  }

  confirmBack() {
    this.reset();
    this.backPage();
  }

  backPage() {
    if (this.registrationForm.dirty) {
      $('#confirmModalback').modal('show');
      return;
    }
    this.location.back();
  }

  clearTimer() {
    clearTimeout(this.timer);
    this.timer = 0;
  }

  ngOnDestroy(): void {
    clearTimeout(this.timer);
    this.timer = 0;
  }

}
